

export class TicketHolderServiceError extends Error {
    constructor(...params: any) {
        super(...params);
        if (params[0] && typeof params[0] === 'string') {

            this.message = params[0];
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TicketHolderServiceError);
        }

        this.name = 'TicketHolderServiceError';
    }

    static fromMalformedResponse(missingParam: string): TicketHolderServiceError {
        return new TicketHolderServiceError(`Response was missing key parameters. Looking for ${missingParam} but not found it`);
    }

    static fromMissingProperty(property:string): TicketHolderServiceError {
        return new TicketHolderServiceError(`Property ${property} is missing in the data`);
    }
}

export default TicketHolderServiceError;
